import { default as Vue } from 'vue'
import { default as OrganizerApplication } from '@/OrganizerApplication.vue'

// Create vue component for organizer application and mount to html element:
new Vue(OrganizerApplication).$mount('#app-mount-point')
